import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "fg-color-blue" }
const _hoisted_4 = { class: "table table-striped table-hover" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "container"
}
const _hoisted_8 = { class: "input-group mb-3" }
const _hoisted_9 = {
  key: 2,
  class: "container"
}

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import { useUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useOrganizationUnitsQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'
    import { useChangeOrganizationUnitCommandV1 } from '@Organizations/Users/commands-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUserOrganizationPage',
  setup(__props) {

    const route = useRoute()

    const id = computed(() =>
        typeof route.params.id === 'string'
            ? route.params.id
            : null
    )

    // ---------------- local state ----------------

    const emailinput = ref('')

    // ---------------- queries ----------------

    const {
        modelUserQueryV1: user,
        runUserQueryV1
    } = useUserQueryV1(id)

    const {
        modelOrganizationUnitsQueryV1: organizationUnitsList,
        runOrganizationUnitsQueryV1
    } = useOrganizationUnitsQueryV1()

    // ---------------- command ----------------

    const {
        invokeChangeOrganizationUnitCommandV1,
        onSucceedChangeOrganizationUnitCommandV1
    } = useChangeOrganizationUnitCommandV1(id)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = "Manage user's organization"
        runOrganizationUnitsQueryV1()
    })

    // ---------------- react to route param ----------------

    watch(id, (newId) =>
    {
        if (newId)
        {
            runUserQueryV1()
        }
    }, { immediate: true })

    // ---------------- derived ----------------
    
    const displayName = computed(() => user.value?.DisplayName)
    const email = computed(() => user.value?.Email)
    const organizationUnitId = computed(() => user.value?.OrganizationUnitId)
    const organizationUnits = computed(() => organizationUnitsList.value?.OrganizationUnits ?? [])

    const organizationUnit = computed(() =>
        organizationUnits.value.find(
            (ou: any) => ou.OrganizationUnitId === organizationUnitId.value
        )
    )

    const organizationUnitName = computed(() => organizationUnit.value?.Name)

    // ---------------- handlers ----------------

    function handleChangeOrganizationUnitCommandV1(ou: any)
    {
        if (!id.value) return

        if (confirm(`Do you really want to change user ${email.value} organization to ${ou.Name}?`))
        {
            invokeChangeOrganizationUnitCommandV1({ OrganizationUnitId: ou.OrganizationUnitId })
        }
    }

    function handleFindUser()
    {
        if (!emailinput.value) return

        window.location.hash =
            `#/admin/organizations/users/manage/organization/${encodeURIComponent(emailinput.value)}`
    }

    onSucceedChangeOrganizationUnitCommandV1(() =>
    {
        window.location.reload();
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: organizationUnitId.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;\">Manage user&#39;s organization</h1><a href=\"/#/admin/organizations/manage\" class=\"btn btn-link btn-sm\"><i class=\"fa fa-arrow-left\" aria-hidden=\"true\"></i> Back </a></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (id.value && _unref(user))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(displayName.value) + " belongs to organization " + _toDisplayString(organizationUnitName.value), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizationUnits.value, (ou) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(ou.Name), 1 /* TEXT */),
                  _createElementVNode("td", null, [
                    (ou.OrganizationUnitId==organizationUnitId.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("i", {
                            class: "fa fa-check-circle fg-color-green",
                            "aria-hidden": "true"
                          }, null, -1 /* CACHED */),
                          _createTextVNode(" Current ", -1 /* CACHED */)
                        ]))]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: ($event: any) => (handleChangeOrganizationUnitCommandV1(ou)),
                          type: "button",
                          class: "btn btn-sm btn-primary"
                        }, " Move to ", 8 /* PROPS */, _hoisted_6))
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ]))
      : (!id.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailinput).value = $event)),
                type: "email",
                class: "form-control",
                placeholder: "Find user by email"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, emailinput.value]
              ]),
              _createElementVNode("div", { class: "input-group-append" }, [
                _createElementVNode("button", {
                  onClick: handleFindUser,
                  class: "btn btn-outline-secondary",
                  type: "button"
                }, "Find")
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("h4", null, "Email '" + _toDisplayString(id.value) + "' not found", 1 /* TEXT */)
          ]))
  ]))
}
}

})